
export default {
  'navbar.lang': 'ChiShona',
  'menu.home': 'Musha',
  'menu.dashboard': 'Dashboard',
  'menu.profile': 'Mbiri',
  'menu.settings': 'Zvirongwa',

  'user.login.title': 'Scan yabudirira!',
  'user.login.subtitle': 'Ipa ruzivo rwako kuti urambe',
  'user.login.username': 'Zita remushandisi kana email',
  'user.login.password': 'Password',
  'user.login.forgot': 'Wakanganwa password?',
  'user.login.button': 'Pinda',

  'user.register.title': 'Gadzira account nyowani',
  'user.register.button': 'Nyoresa',
  'user.register.success': 'Account yagadzirwa. Tarisa email kusimbisa.',

  'user.login.welcome.subheading': 'Ndatambira munyika inobatana rusununguko neupenyu hunosarudzika! Skan. Tora mapoinzi. Rarama wakasununguka. Rarama wakasarudzika',
  'user.login.description': 'Wakabudirira kuskan QR code yedu. Pinda kana Nyoresa pazasi kuti utore mibairo nemapoinzi',
  'user.login.signin.title': 'Pinda',
  'user.login.signin.sub': 'Kuti upinde nyora nhamba yako yefoni; tichatumira verification code',
  'user.login.phoneNumberLabel': 'Nhamba yefoni',
  'user.login.enterPhonePlaceholder': 'Nyora nhamba yefoni',
  'user.login.invalidPhone': 'Nhamba yefoni isiri correct',
  'user.login.phoneRequired': 'Nhamba yefoni inodiwa',
  'user.login.signingIn': 'Kupinda...',
  'user.login.continue': 'Enderera',
  'user.login.noAccount': 'Hauna account?',
  'user.login.signup': 'Nyoresa',
  'user.login.footerCopyright': 'Kodzero © {year}. Yakapihwa ne Exceptional Brands',

  'user.register.welcome': 'Mauya!',
  'user.register': 'Nyoresa kuti utore mibairo yako',
  'user.register.description': 'Zadza mashoko pazasi kuti uwane mapoinzi, uvhure mibairo uye uwine mibairo inoshamisa',
  'user.register.phone.label': 'Nhamba yefoni',
  'user.register.phone.placeholder': 'Nyora nhamba yefoni',
  'user.register.phone.required': 'Nhamba yefoni inodiwa',
  'user.register.phone.invalid': 'Nhamba yefoni isiri correct',
  'user.register.name.label': 'Zita rako',
  'user.register.name.placeholder': 'semuenzaniso: Mark',
  'user.register.name.required': 'Zita rinodiwa',
  'user.register.ageGroup.label': 'Age group (Optional)',
  'user.register.gender.label': 'Gender (Optional)',
  'user.register.gender.male': 'Murume',
  'user.register.gender.female': 'Mukadzi',
  'user.register.terms.agreement': 'Nekuuramba, unobvuma {termsLink} uye {privacyLink}.',
  'user.register.terms.termsOfService': 'Terms of Service',
  'user.register.terms.privacyPolicy': 'Privacy Policy',
  'user.register.creating': 'Kugadzira Profile…',
  'user.register.create': 'Gadzira Profile',
  'user.register.alreadyAccount': 'Une account here?',
  'user.register.signin': 'Pinda',

  "user.welcome.welcome": "Mauya!",
  "user.welcome.welcome_name": "Mauya {name}!",
  'user.welcome.points_earned': 'Makorokoto, wawana',
  'user.welcome.thank_you': 'Ndatenda neku nyoresa!',
  'user.welcome.earn_more_points': 'Kuti uwane mamwe mapoinzi, ongorora zvimwe zvigadzirwa zvawakawana kwatiri.',
  'user.welcome.continue': 'Enderera',
  'user.welcome.logging_in': 'Kupinda...',
  "user.welcome.welcome_reward": "Mubairo weKugamuchira",
  "user.welcome.points_label": "mapoinzi!",
  "user.welcome.loggingIn": "Kupinda...",

  "product.button.continue": "Enderera",
  "product.button.selectToContinue": "Sarudza chigadzirwa kuti uenderere mberi",

  'scansuccess.review.heading': 'Unoona sei chigadzirwa ichi?',
  'scansuccess.review.continue': 'Retailer code (Optional)',
  'scansuccess.review.select-product': 'Wedzera retailer code kuti uwane mapoinzi',
  'scansuccess.review.review-products': 'Tumira ongororo',

  "product.retailerCode.label": "Retailer Code",
  "product.retailerCode.requiredLabel": "Inodiwa",
  "product.retailerCode.optionalLabel": "Optional",
  "product.retailerCode.placeholder": "Nyora retailer code",
  "product.retailerCode.aria": "Retailer code",
  "product.retailerCode.hintRequired": "Retailer code inodiwa kuti utumire ongororo iyi",
  "product.retailerCode.hintOptional": "Wedzera retailer code kuti uwane mamwe mapoinzi",
  "product.retailerCode.error.required": "Retailer code inodiwa",
  "product.retailerCode.error.invalid": "Retailer code isiri correct",

  "profile.title": "Profile Yangu",
  "profile.tier.member": "Nhengo",
  "profile.points": "Mapoinzi",
  "profile.pointsEarned": "Mapoinzi Awawana",
  'scansuccess.continue': 'Enderera',
  "profile.completeTitle": "Pedzisa Profile Yako",
  "profile.completeSubtitle": "Wana {points} mapoinzi ekuwedzera!",
  "profile.completedTitle": "Profile Yapera! ✓",
  "profile.completedSubtitle": "Wawana ese {points} mapoinzi ekuwedzera!",
  "profile.completeButton": "Pedzisa Profile (+{points} pt)",
  "profile.redeem": "✓ Profile Yapera",
  "product.review.placeholder": "Nyora ongororo... (tsamba imwe inoshanda)",
  "product.review.ariaLabel": "Nyora ongororo",
  "profile.field.phoneNo.label": "Nhamba yefoni",
  "profile.field.phoneNo.add": "Wedzera nhamba yako yefoni",
  "profile.field.email.label": "Email Address",
  "profile.field.email.add": "Wedzera email yako",
  "profile.field.countryCode.label": "Nzvimbo",
  "profile.field.countryCode.add": "Wedzera nzvimbo yako",
  "profile.field.name.label": "Zita",
  "profile.field.name.add": "Wedzera zita rako",
  "profile.field.dateOfBirth.label": "Zuva rekuzvarwa",
  "profile.field.dateOfBirth.add": "Wedzera zuva rekuberekwa",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Gadzirisa {field}",
  "profile.modal.completeTitle": "Pedzisa Profile Yako",
  "profile.modal.update": "Gadzirisa",
  "profile.modal.complete": "Pedzisa Profile",
  "profile.modal.cancel": "Dzokera",
  "profile.completedBadge": "Wawana mapoinzi {points}",
  "profile.progressPercent": "{percent}% Yapedzwa",
  "profile.progressRemaining": "{percent}% yasara",
  'scansuccess.congratulations.heading': 'Makorokoto!',
  'scansuccess.congratulations.continue': 'Wawana',
  'scansuccess.congratulations.select-product': 'Ndatenda neku ongororo yako',
  'scansuccess.congratulations.review-products': 'Kuti uwane mamwe mapoinzi, ongorora zvimwe zvigadzirwa',
  'scansuccess.congratulations.create': 'Enda kuDashboard',
  'user.brand-product-review.title': 'Sarudza Brand & Chigadzirwa Kuti Uenderere',
  'user.brand-product-review.continue': 'Enderera',
  'user.brand-product-review.select-product': 'Sarudza chigadzirwa kuti uenderere',
  'user.brand-product-review.review-products': 'Ongorora zvigadzirwa zvedu kuti uwane mapoinzi',
  'user.brand-product-review.rate-product': 'Ndapota ongorora zvisingaite chimwe chigadzirwa kuti uenderere',
  'user.brand-product-review.footer': 'Kodzero © {year}. Yakapihwa ne Exceptional Brands',
  'scansuccess.title': 'Mhedzisiro yeScan',
  'scansuccess.scan.message': 'Ndatenda — scan yako yabudirira.',
  'scansuccess.scan.instructions': 'Unogona kutora mapoinzi, kunyora ongororo kana kunyoresa zvipo.',
  'scansuccess.signup.title': 'Nyoresa kuti utore mibairo',
  'scansuccess.signup.button': 'Nyoresa',
  'scansuccess.welcomepoints.title': 'Mapoinzi eKugamuchira',
  'scansuccess.welcomepoints.pointsLabel': 'Mapoinzi akapiwa',
  'scansuccess.brandproductreview.title': 'Ongororo yeBrand & Chigadzirwa',
  'scansuccess.brandproductreview.leaveReview': 'Siya ongororo',
  'scansuccess.productreview.title': 'Ongororo yeChigadzirwa',
  'scansuccess.productreview.submit': 'Tumira ongororo',
  'scansuccess.congratulations.title': 'Makorokoto!',
  'scansuccess.congratulations.message': 'Wawana mapoinzi — tarisa dashboard yako kuti uatore.',
  'scansuccess.noAccount': 'Hauna account?',
  'scansuccess.signup': 'Nyoresa',

  "user.register.createProfile": "Gadzira Account",
  "user.register.creatingProfile": "Kugadzira Account...",
  "user.register.termsOfService": "Terms of Service",
  "user.register.privacyPolicy": "Privacy Policy",

  'dashboard.multiplescans.title': 'Scans zhinji',
  'dashboard.multiplescans.instructions': 'Tungamira scans dzakawanda nemibairo pamwechete.',
  'dashboard.title': 'Mauya!',
  'dashboard.balance': 'Chiyero chako',
  'dashboard.balance-sub': 'mapoinzi',
  'dashboard.redeem': 'Shandisa',
  'dashboard.stat': 'Scans yose',
  'dashboard.label': 'Mibairo yawanikwa',
  'dashboard.redeem.title': 'Shandisa mapoinzi ako',
  'dashboard.redeem.success': 'Shandisa mibairo',
  'dashboard.primary-sub': 'Shandisa mapoinzi ako kuvhura mibairo',
  'dashboard.secondary-btn': 'Scan zvakare',
  'dashboard.secondary': 'Rondedzera shamwari',
  'dashboard.loyalty': 'Matanho ehutano',
  'dashboard.5000pts': '5000 mapoinzi',
  'dashboard.100pts': '100 mapoinzi kuenda Platinum',
  'dashboard.almost-there': 'Tinoswedera!',
  'dashboard.recent': 'Basa remazuva ano',
  'settings.title': 'Zvirongwa',
  'settings.balance': 'Gold Member',
  'settings.balance-sub': 'Mapoinzi',
  'settings.redeem': 'Akaunti',
  'settings.stat': 'Gadzirisa Profile',
  'settings.label': 'Update ruzivo rwega',
  'settings.redeem.title': 'Zvido',
  'settings.redeem.success': 'Notifications',
  'settings.primary-sub': 'Push & email preferences',
  'settings.secondary-btn': 'Mutauro',
  'settings.secondary': 'English (US)',
  'settings.loyalty': 'Rubatsiro & Mitemo',
  'settings.5000pts': 'Rubatsiro & Support',
  'settings.100pts': 'FAQ, bata nesu',
  'settings.almost-there': 'Terms & Conditions',
  'settings.recent': 'Legal information',
  'settings.points': 'Privacy policy',
  'settings.data': 'Data protection info',
  'settings.sign': 'Sign out',

  'profile.balance': '% Yapedzwa',
  'profile.balance-sub': '% yasara',
  'profile.stat': 'Profile Information',
  'profile.label': 'pt',
  'profile.redeem.title': 'Connect Social Media',
  'profile.redeem.success': 'Earn points for each connection!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Connect your social media for a 20 point bonus!',
  'profile.recent': 'Fill in the following fields to complete your profile and earn ',
  

  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "South Africa",
  "country.BJ": "Benin",
  "country.AE": "United Arab Emirates",

  "dashboard.welcome": "Mauya!",
  "dashboard.user.unknown": "User",
  "dashboard.balanceLabel": "Chiyero chako",
  "dashboard.coinsAlt": "coins",
  "dashboard.pointsLabel": "mapoinzi",
  "dashboard.redeemBtn": "Shandisa mapoinzi",
  "dashboard.totalScans": "Total Scans",
  "dashboard.rewardsWon": "Mibairo yawana",
  "dashboard.redeemTitle": "Shandisa mapoinzi ako",
  "dashboard.redeemRewards": "Shandisa mibairo",
  "dashboard.redeemSub": "Use your points to unlock rewards",
  "dashboard.reviewProducts": "Ongorora Products",
  "dashboard.referFriend": "Refer Friend",
  "dashboard.tiersTitle": "Loyalty Tiers",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "Almost there!",
  "dashboard.recentActivityTitle": "Recent Activity",
  "dashboard.share.title": "Join Exceptional Brands",
  "dashboard.share.text": "Join me on Exceptional Brands! Earn points by scanning products and get amazing rewards. Use my referral link: {url}",
  "dashboard.shareModalTitle": "Share with Friends",
  "dashboard.shareModalDesc": "Share Exceptional Brands with your friends and earn bonus points when they join!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Your referral link:",
  "dashboard.share.instagramCopied": "Link copied to clipboard - paste into Instagram",
  "dashboard.footerCopyright": "Copyright © {year}. Powered by Exceptional Brands",
  "dashboard.aria.welcome": "Welcome panel",
  "dashboard.aria.notifications": "Notifications",
  "dashboard.aria.settings": "Settings",
  'dashboard.redeem.points': 'Redeem Your Points',
  'dashboard.redeem.subtitle': 'Use your points to unlock rewards',
  'dashboard.redeem.sub': 'points',
  'dashboard.redeem.progress': 'Progress toward Platinum',
  'dashboard.redeem.stat': 'Available Rewards',
  'dashboard.redeem.label': 'Redeem',
  'dashboard.redeem.need': 'Required',
  'dashboard.redeem.prize': 'Prize download',
  'dashboard.redeem.scan': 'The more you scan the higher your chances of winning something awesome',
  'dashboard.redeem.recent': 'Recent Activity',
  'global.back': 'Back',
  'global.next': 'Next',
  'global.search.placeholder': 'Search...',
  'validation.required': 'This field is required',
  'error.404.title': 'Page not found',
  'error.404.subTitle': "Sorry, we can't find the page you are looking for.",
};
